import { useContext } from "react";
import {
  FirmaFiltersContext,
  FirmaFiltersEventContext,
} from "../../context/FiltersContext";
import FiltersSidebar from "./FiltersSidebar";
import CustomFilter from "./custom/CustomFilter";
import { FirmaCustomFilterConfig } from "../../config/filter/CustomFilterConfig";
import FirmaFirmanummerFilter from "../pages/firma/id/filters/FirmaFirmanummerFilter";
import FirmaSelskabsformFilter from "../pages/firma/id/filters/FirmaSelskabsformFilter";
import FirmaFirmatypeFilter from "../pages/firma/id/filters/FirmaFirmaTypeFilter";
import FirmaStatusFilter from "../pages/firma/id/filters/FirmaStatusFilter";
import FirmaGeografiFilter from "../pages/firma/id/filters/FirmaGeografiFilter";
import FirmaTilsynFilter from "../pages/firma/id/filters/FirmaTilsynFilter";
import FirmaCVRFilter from "../pages/firma/id/filters/FirmaCVRFilter";
import FirmaStartDatoFilter from "../pages/firma/id/filters/FirmaStartDatoFilter";
import FirmaSlutDatoFilter from "../pages/firma/id/filters/FirmaSlutDatoFilter";

export default function FiltersFirma() {
  const updateFilters = useContext(FirmaFiltersEventContext);

  return (
    <FiltersSidebar
      contextType="Firma"
      queryFilterEventContext={FirmaFiltersEventContext}
      onReset={() => {
        updateFilters({
          event: "reset",
        });
      }}
    >
      <FirmaStatusFilter />
      <FirmaFirmatypeFilter />
      <FirmaSelskabsformFilter />
      <FirmaFirmanummerFilter />
      <FirmaGeografiFilter />
      <FirmaTilsynFilter />
      <FirmaCVRFilter />
      <FirmaStartDatoFilter />
      <FirmaSlutDatoFilter />

      <CustomFilter
        filterConfig={FirmaCustomFilterConfig}
        queryFilterContext={FirmaFiltersContext}
        queryFilterEventContext={FirmaFiltersEventContext}
      />
    </FiltersSidebar>
  );
}
